import React, { useEffect, useState } from 'react'
import "./style.scss"
import { subscribeErrorUpdate } from '../../Events/utils.events'
import { cross } from '../../../../images/icon'

const ErrorWrapper = () => {
    const [errorMessage, setErrorMessage] = useState(false)
    const handleErrorMessage = (data) => {
        setErrorMessage(data)
        setTimeout(() => {
            setErrorMessage(false)
        },10000)
    }
    useEffect(() => {
        subscribeErrorUpdate(handleErrorMessage)
    }, [])
    return (<>
        {errorMessage ? <div className='error-wrapper site-cta-background-color'>
            {cross(`#ffffff`)} {errorMessage}
        </div> : <></>}
    </>)
}

export default ErrorWrapper